import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  navigationShow: boolean = false;userLoginData:any=[];currentUrl:any;LinkDisable:any=0;
  constructor(private router: Router,private activatedRoute: ActivatedRoute,private modalService: NgbModal) {
    if(activatedRoute.snapshot.url[0].path == 'viewer_question'){
    this.LinkDisable = 1;
    }
   }
  navigationEvent() {
    //this.navigationShow = !this.navigationShow; 
    //localStorage.setItem('userLoginData','');
    localStorage.removeItem('userLoginData');
    localStorage.removeItem('userLoginPass');
    //console.log(localStorage.removeItem('userLoginData'));
    this.router.navigateByUrl('/'); 
    
    }
    navigationToggle(){
      this.navigationShow = !this.navigationShow;
    }
    
  ngOnInit(): void {
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
     // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
     // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
}
